import { RAWSTER_SUPPORT_EMAIL } from "./RawsterLayout";
import { BrandedHeading, RawsterBrand } from "./RawsterBrand";

export function RawsterSupport() {
  return (
    <main className="rawster-main rawster-doc">
      <header className="rawster-doc-header">
        <BrandedHeading as="h1">Support</BrandedHeading>
        <RawsterBrand className="rawster-brand-subtitle" />
        <p className="rawster-doc-updated">
          We&apos;re here to help with the Rawster app.
        </p>
      </header>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Contact Us</BrandedHeading>
        <p>
          For support, feedback, account help, or privacy and data deletion requests,
          email us at{" "}
          <a href={`mailto:${RAWSTER_SUPPORT_EMAIL}`}>{RAWSTER_SUPPORT_EMAIL}</a>.
          We aim to respond within 1 to 2 business days.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Frequently Asked Questions</BrandedHeading>

        <p>
          <strong>How does Sign in with Apple work?</strong>
        </p>
        <p>
          On iOS you can sign in with Apple. Apple may share your name and email once at
          first sign-in. We use that to set up your profile. We do not ask you to create
          a separate email-and-password account afterward. See our Privacy Policy for
          details.
        </p>

        <p>
          <strong>Why does Rawster AI ask about OpenAI?</strong>
        </p>
        <p>
          Rawster AI (Pro) sends data to OpenAI only after you tap &quot;I agree — send my
          data to OpenAI&quot; on the first-use consent screen. If you tap &quot;Not
          now,&quot; no data is sent. See the Privacy Policy for what is and is not sent.
        </p>

        <p>
          <strong>What stays on my phone vs the cloud?</strong>
        </p>
        <p>
          Most Radar notes and many personal logs stay on your device. When you sign in,
          connection features, match profile, shared pulses, questions, AI chat history,
          and similar data sync through Firebase. See the Privacy Policy.
        </p>

        <p>
          <strong>How do I cancel my subscription?</strong>
        </p>
        <p>
          Open iOS Settings → Apple ID → Subscriptions → Rawster → Cancel Subscription.
          Access continues until the end of your current billing period.
        </p>

        <p>
          <strong>How do I delete my account or data?</strong>
        </p>
        <p>
          You can export or delete local data in Settings. For full account deletion, use
          in-app account deletion where available, or email{" "}
          <a href={`mailto:${RAWSTER_SUPPORT_EMAIL}`}>{RAWSTER_SUPPORT_EMAIL}</a> from
          the address or phone associated with your account. We will confirm once deletion
          is complete, subject to legal retention requirements.
        </p>

        <p>
          <strong>Does Rawster upload my contacts or photos?</strong>
        </p>
        <p>
          Contacts are used only when you pick someone to add on Radar; your full contact
          list is not uploaded. Photos are accessed only when you choose a profile photo
          or screenshot; image files are not uploaded to our servers for OCR or profile
          storage.
        </p>

        <p>
          <strong>The app won&apos;t open or keeps crashing.</strong>
        </p>
        <p>
          Force close Rawster, restart your device, then open the app again. Check the App
          Store for an update. If the issue continues, contact us with your device model
          and OS version.
        </p>

        <p>
          <strong>I switched devices. How do I restore my data?</strong>
        </p>
        <p>
          Sign in on your new device with the same Apple or phone account. Cloud-synced
          data should appear after sign-in. On-device-only Radar data may not transfer
          unless you exported it from your previous device.
        </p>

        <p>
          <strong>Billing or refund questions</strong>
        </p>
        <p>
          Purchases and refunds are handled by Apple according to Apple&apos;s policies.
          You can request a refund through your purchase history in the App Store. For
          other billing questions, email us at the address above.
        </p>
      </section>

      <section className="rawster-doc-section">
        <BrandedHeading as="h2">Troubleshooting</BrandedHeading>
        <ol>
          <li>Close and reopen the Rawster app.</li>
          <li>Restart your phone or tablet.</li>
          <li>Install the latest version from the App Store.</li>
          <li>Ensure you have free storage and a stable internet connection if using sync.</li>
          <li>
            As a last resort, reinstall the app. Note: locally stored data may be lost
            unless you exported it or use account sync.
          </li>
        </ol>
        <p>
          If problems persist, contact{" "}
          <a href={`mailto:${RAWSTER_SUPPORT_EMAIL}`}>{RAWSTER_SUPPORT_EMAIL}</a> with a
          short description of the issue.
        </p>
      </section>
    </main>
  );
}
